import PUBLIC_EMAIL_DOMAINS from './publicEmailDomains'

const DOMAIN_FORMAT_REGEXP = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)+$/

// Normaliza e valida um domínio corporativo.
// Retorna { normalized, error } — error é null quando válido.
const validateDomain = (rawDomain, existingDomains = []) => {
  const normalized = (rawDomain || '').trim().toLowerCase().replace(/^@/, '')

  if (!normalized) {
    return { normalized, error: 'Informe um domínio.' }
  }

  if (!DOMAIN_FORMAT_REGEXP.test(normalized)) {
    return {
      normalized,
      error: 'Domínio inválido. Use o formato nome.com ou nome.com.br.',
    }
  }

  if (PUBLIC_EMAIL_DOMAINS.includes(normalized)) {
    return {
      normalized,
      error:
        'Domínios de e-mail gratuitos não podem ser liberados, pois abririam o portal para qualquer pessoa.',
    }
  }

  const alreadyAdded = existingDomains.some(
    (domain) => (domain || '').toLowerCase() === normalized,
  )
  if (alreadyAdded) {
    return { normalized, error: 'Este domínio já foi adicionado.' }
  }

  return { normalized, error: null }
}

export default validateDomain
